import React, { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { PromoProvider } from "../contexts/PromoContext";

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return <PromoProvider>{children}</PromoProvider>;
};

export default Layout;
